export const imageRegex = /\.(jpeg|jpg|gif|png|svg|bmp)$/i;
